<imp-modal-header [title]="'EXTEND_SESSION_DIALOG_TITLE' | translate" />
<imp-modal-body>
  <imp-feedback-panel
    [message]="'EXTEND_SESSION_DIALOG_INFORMATION' | translate"
    type="infoLowContrast" />
</imp-modal-body>
<imp-modal-footer>
  <imp-button
    variant="primary"
    label="EXTEND_SESSION_DIALOG_EXTEND_BUTTON"
    [disabled]="extendDisabled()"
    (action)="extendSession()" />
</imp-modal-footer>
